import { Check, Person, Remove } from "@mui/icons-material";
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { capitalizeWords } from "src/shared/global/helpers";
import { userState } from "src/store/user/userState";
import { checkIsOwner } from "../utils/ownerUtils";
import { showModalConfirmFamilyGroupState, tutRutConfirmState } from "../atom";
import { AlertModal } from "./AlertModal";
import { useState } from "react";
import queryString from "query-string";
import { decryptString } from "src/shared/global/cryptoJSUtilities";

export const TutoresList = ({
  tutoresGroup = [],
  removeFamilyMember = () => {},
  payloadToken = {},
}) => {
  const setTutRutConfirm = useSetRecoilState(tutRutConfirmState);
  const setShowModalConfirmFamilyGroup = useSetRecoilState(
    showModalConfirmFamilyGroupState
  );

  const user = useRecoilValue(userState);
  const activeAccount = checkIsOwner(user);

  const handleConfirm = (tutRut) => {
    setTutRutConfirm(tutRut);
    setShowModalConfirmFamilyGroup(true);
  };

  const [showAlert, setShowAlert] = useState(false);
  const [tutRut, setTutRut] = useState("");

  const params = queryString.parse(window.location.search);

  if (params.tut && tutoresGroup.length === 1) {
    const tutRutParam = decryptString(params.tut);
    console.log("Decrypted tutRut:", tutRutParam);

    setTutRutConfirm(tutRutParam);
    setShowModalConfirmFamilyGroup(true);
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.hash
    );
  }

  return (
    <div>
      <AlertModal
        open={showAlert}
        onClose={() => setShowAlert(false)}
        onConfirm={() => {
          removeFamilyMember({
            tutRut: tutRut,
            rutPaciente: payloadToken?.Username,
            actorRol: "paciente",
          });
          setShowAlert(false);
        }}
        title="Confirmar rechazo de invitación"
        message="¿Estás seguro de que deseas rechazar esta invitación o salir de este grupo?"
      />
      <Stack>
        <Typography variant="subtitle2" fontWeight={600}>
          Grupo Familiar donde soy invitado
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Aquí puedes ver los grupos familiares a los que has sido invitado.
          Puedes confirmar o rechazar la invitación.
        </Typography>
      </Stack>
      <List>
        {tutoresGroup.length === 0 && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: "center", mt: 2 }}
          >
            No hay tutores registrados.
          </Typography>
        )}
        {tutoresGroup.length > 0 &&
          tutoresGroup.map(
            ({
              tutRut,
              tutNombres,
              tutPaterno,
              tutMaterno,
              tutCuentaVerificada,
            }) => (
              <ListItem
                key={tutRut}
                secondaryAction={
                  <Stack direction="row" spacing={1}>
                    {!tutCuentaVerificada && (
                      <IconButton
                        edge="end"
                        aria-label="confirm"
                        onClick={() => handleConfirm(tutRut)}
                        disabled={!activeAccount.isOwner}
                      >
                        <Check />
                      </IconButton>
                    )}
                    <IconButton
                      edge="end"
                      aria-label="remove"
                      disabled={!activeAccount.isOwner}
                      onClick={() => {
                        setShowAlert(true);
                        setTutRut(tutRut);
                      }}
                    >
                      <Remove />
                    </IconButton>
                  </Stack>
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    <Person />
                  </Avatar>
                </ListItemAvatar>
                <Stack p={0} spacing={0} sx={{ width: "100%" }}>
                  <Stack>
                    <ListItemText
                      primaryTypographyProps={{ fontWeight: 600 }}
                      primary={capitalizeWords(
                        `${tutNombres} ${tutPaterno} ${tutMaterno}`
                      )}
                      secondaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                      secondary={`${
                        tutCuentaVerificada ? "" : "Pendiente de confirmación"
                      }`}
                    />
                  </Stack>
                </Stack>
              </ListItem>
            )
          )}
      </List>
    </div>
  );
};
